import { render, staticRenderFns } from "./depo.vue?vue&type=template&id=ea0010ee&scoped=true&"
import script from "./depo.vue?vue&type=script&lang=js&"
export * from "./depo.vue?vue&type=script&lang=js&"
import style0 from "./depo.vue?vue&type=style&index=0&id=ea0010ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0010ee",
  null
  
)

export default component.exports